import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Space, Spin, Typography } from "antd";
import LockCertificateApi from "apis/LockCertificateApi";
import ServiceApi from "apis/ServiceApi";
import { showNotification } from "common";
import GloabalConst from "common/GloabalConst";
import Titles from "common/Titles";
import TutorialCode from "common/TutorialCode";
import HeaderLogo from "components/HeaderLogo";
import {
  OBJECT_COMPENSATION,
  OBJECT_LABEL_EXTEND,
} from "constants/objectCompensation";
import ConfirmExtend from "pages/CompensationExtend/components/ConfirmExtend";
import FormExtend from "pages/CompensationExtend/components/FormExtend";
import SuccessExtend from "pages/CompensationExtend/components/SuccessExtend";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function CompensationExtend() {
  const [loading, setLoading] = useState(false);
  const [showFileDk01, setShowFileDk01] = useState(false);
  const [dataCert, setDataCert] = useState({});
  const [listPackage, setListPackage] = useState([]);
  const [dataCheckReq, setDataCheckReq] = useState();

  const location = useLocation();
  const typeRe = new URLSearchParams(location.search).get("type") ?? null;
  const [type, setType] = useState(typeRe);

  const requestType = new URLSearchParams(location.search).get("requestType") ?? "CAP_BU";

  const fetchDetailPackage = async () => {
    if (!type) return;
    setLoading(true);
    try {
      const res = await ServiceApi.getListPackageExtend({
        object: type,
      });
      if (res?.data?.status === 200) {
        const newArr = res?.data?.data?.map((item) => ({
          ...item,
          value: item.id,
          label:
            OBJECT_LABEL_EXTEND.find(
              (itemL) => itemL.value === item?.extendType
            )?.label ?? item.name,
        }));
        const sortedArr = newArr.sort((a, b) => a.extendType - b.extendType);
        setListPackage(sortedArr);
        return newArr;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const fetchDataDetail = async (resDetailCert) => {
    setLoading(true);
    try {
      const resCheck = await ServiceApi.checkrequestcapbu({requestType});

      if (resCheck.data.status === 200) {
        if (resCheck.data.data?.status) {
          const dataDetail = resCheck.data.data;
          const statusCheck = dataDetail.status;

          setDataCheckReq(dataDetail);
          if (OBJECT_COMPENSATION.WAIT_SIGN === statusCheck) {
            // fetchDataFileDK01(resDetailCert, dataDetail);
          }
          return dataDetail
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const fetchDataDetailCert = async () => {
    setLoading(true);
    try {
      const res = await ServiceApi.getCertInfoCapBu();
      if (res?.data?.data?.status === 200) {
        const dataDetail = res?.data?.data?.data;
        setDataCert(dataDetail);
        !type && setType(dataDetail?.type)
        return dataDetail;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const [base64File, setBase64File] = useState();

  const fetchDataFileDK01 = async (dataC, dataRe) => {
    const dataCertCheck = dataC ?? dataCert;
    const dataRequestCheck = dataRe ?? dataCheckReq;
    setLoading(true);
    try {
      const dataCert = {
        certificateSerial: dataCertCheck?.serinumberCert,
        object: dataRequestCheck?.object,
        idRequest: dataRequestCheck?.id,
      };
      const res = await LockCertificateApi.generateDk01(dataCert);
      if (res?.data?.status === 200) {
        setBase64File(res?.data?.data);
        setShowFileDk01(true);
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const nextStep = () => {
    Promise.all([fetchDataDetail(),fetchDataDetailCert(), fetchDetailPackage()]).then(
      ([resDataCheckReq,resDetailCert, resDetailPackage]) => {
        const statusCheck = resDataCheckReq.status;
        if (OBJECT_COMPENSATION.WAIT_SIGN === statusCheck) {
          fetchDataFileDK01(resDetailCert, resDataCheckReq);
        }
      }
    );
  };

  useEffect(() => {
    localStorage.setItem(
          GloabalConst.TUTORIAL_CODE,
          TutorialCode.RENEWCERT_COMPENSATION_EXTEND.value
        );

    Promise.all([fetchDataDetailCert(), fetchDetailPackage()]).then(
      ([resDetailCert, resDetailPackage]) => {
        fetchDataDetail(resDetailCert);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFileDk01,type]);

  return (
    <Spin
      spinning={loading}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <Helmet>
        <title>{Titles.COMPENSATION_EXTEND.value}</title>
      </Helmet>
      <Flex
        justify="center"
        align="center"
        vertical={true}
        style={{
          minHeight: "var(--min-height-body)",
        }}
      >
        <div className="w-full">
          <Flex justify="center" align="center">
            <Space direction="vertical" align="center">
              <HeaderLogo />
              <Typography.Title level={3}>
                YÊU CẦU GIA HẠN CHỨNG THƯ SỐ USB TOKEN
              </Typography.Title>
            </Space>
          </Flex>
          {(!dataCheckReq ||
            dataCheckReq?.status === OBJECT_COMPENSATION.WAIT_SIGN) && (
            <>
              {showFileDk01 ? (
                <ConfirmExtend
                  fetchDataDetail={fetchDataDetail}
                  setShowFileDk01={setShowFileDk01}
                  base64File={base64File}
                  setLoading={setLoading}
                  dataCert={dataCert}
                  dataCheckReq={dataCheckReq}
                />
              ) : (
                <Flex justify="center" align="middle">
                  <FormExtend
                    setLoading={setLoading}
                    dataCert={dataCert}
                    listPackage={listPackage}
                    fetchDataDetail={fetchDataDetail}
                    setShowFileDk01={setShowFileDk01}
                    fetchDataFileDK01={fetchDataFileDK01}
                    dataCheckReq={dataCheckReq}
                    nextStep={nextStep}
                    requestType={requestType}
                  />
                </Flex>
              )}
            </>
          )}

          {dataCheckReq?.status === 3 && (
            <SuccessExtend
              setLoading={setLoading}
              dataCheckReq={dataCheckReq}
              dataCert={dataCert}
            />
          )}
        </div>
      </Flex>
    </Spin>
  );
}
